import useValidation from 'Components/ContractGenerator/shared/helpers/useValidation';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { contractGeneratorOperations } from 'Redux/ducks/contractGenerator';
import Alert from 'ViatoUi/Extranet/Surfaces/Alert';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';
import DimmerPopup from 'ViatoUi/Web/DimmerPopup';

const ValidationError = ({ showPopup, setShowPopup }) => {
	const { t } = useTranslation('contractGenerator');
	const dispatch = useDispatch();
	const { validationErrors } = useValidation();

	return (
		<DimmerPopup
			buttonText={t('app.userActions.close')}
			headline={t('layouts.footer.buttonStep2.missingInput')}
			visible={showPopup}
			onClick={() => {
				const yOffset = 150;
				const element = document.getElementById(`viato-contract-generator-form-${validationErrors[0].formName}`);
				const y = element.getBoundingClientRect().top + window.pageYOffset - yOffset;

				window.scrollTo({ top: y, behavior: 'smooth' });

				dispatch(contractGeneratorOperations.setErrorMessagesVisible(true));
				setShowPopup(!showPopup);
			}}
		>
			{t('layouts.footer.buttonStep2.checkInputs')}:
			<Spacer height='s' />
			{validationErrors.map(validationError => (
				<Fragment key={encodeURI(validationError.label)}>
					<Alert type='error'>
						<strong>{validationError.label}</strong>
						<br />

						{validationError.errorMessages.map(errorMessage => (
							<div key={encodeURI(errorMessage)}>{errorMessage}</div>
						))}
					</Alert>
					<Spacer height='s' />
				</Fragment>
			))}
		</DimmerPopup>
	);
};

ValidationError.propTypes = {
	showPopup: PropTypes.bool.isRequired,
	setShowPopup: PropTypes.func.isRequired
};

export default ValidationError;
